<div class="popup-backdrop">
  <div class="popup-modal" style="direction: ltr">
    <h2>Pathologies taken Today</h2>
    <button class="close-btn" (click)="onClose()">&times;</button>
    <div *ngFor="let exam of examNames">
      <h3>{{ exam }}</h3>
      <ul>
        <li *ngFor="let pathology of exams[exam]; let i = index">
          <span style="display: flex; justify-content: space-between; width: 100%;">#{{ i + 1 }} - {{ pathology.Type+ ': ' + pathology.Comments }} - Barcode: 
            <ng-container *ngIf="scanning && pathologyScanning === pathology.AutoIndex">
              <input class="fulltext pathText" [(ngModel)]="barcodeInputPathology" [ngModelOptions]="{standalone: true}" type="number"
                (ngModelChange)="onBarcodeInputChange()"
                (blur)="finishScan()"
                (keyup.enter)="finishScan()" 
                #barcodeInputP />
            </ng-container>
            <ng-container *ngIf="!(scanning && pathologyScanning === pathology.AutoIndex)">
              {{ pathology.BarCode || 'Not scanned' }}
              <button class="btn" (click)="scanExistingPathology(pathology.AutoIndex)" *ngIf="!scanning">Scan Barcode</button>
            </ng-container>
          </span>
        </li>
      </ul>
    </div>
  </div>
</div>
